<template>
  <div>
    <div class="card process p-4" v-if="parser?.id">
      <div class="title">
        <div class="wrap">
          <h5>Сбор данных в процессе</h5> <br>
          <div class="sub-title">Режим: <span v-for="type in parser.types">{{ type_names[type] }}&nbsp;</span>
          </div>
        </div>
        <div class="ms-auto">
          <h4>{{ parser.status?.all - parser?.status?.not_ready }} / {{ parser.status?.all }}</h4> <br>
          <div class="help-text">ссылок обработано</div>
        </div>
      </div>
      <div class="progress" role="progressbar" :aria-valuenow="persent" aria-valuemin="0"
           aria-valuemax="100">
        <div class="progress-bar" :style="{width: persent+'%'}">{{ persent }}%</div>
      </div>
      <div class="line">
        <span>Начато: <span
            v-if="parser.date_start">{{ $moment(parser.date_start).format('DD.MM.YYYY HH:mm') }}</span></span>
        <span>Ожидаемое время завершения: ~
          <span
              v-if="parser.time_to_end.d">{{ $pluralise(parser.time_to_end.d, ["день", "дня", "дней"]) }}</span>
          <span
              v-if="parser.time_to_end.h">{{ $pluralise(parser.time_to_end.h, ["час", "часа", "часов"]) }}</span>
          <span
              v-if="parser.time_to_end.m">{{ $pluralise(parser.time_to_end.m, ["минута", "минуты", "минут"]) }}</span>
        </span>
      </div>

    </div>

    <div class="line bottom">
      <div>
        <i class="bi bi-circle-fill text-primary"></i> <b>Парсинг активен</b>
      </div>
    </div>

  </div>

</template>

<script>

export default {
  name: 'ParserStatus',
  props: {
    parser: {type: Object}
  },
  data() {
    return {
      type_names: {
        review: "Сбор отзывов",
        rating: "Сбор оценок"
      }
    }
  },
  watch: {

  },
  mounted: function () {

  },
  computed: {
    persent(){
      let current = this.parser.status.all - this.parser.status.not_ready;
      let all = this.parser.status.all || 1
      return Math.round((current/all)*100)
    }
  },

  methods: {

  }
}

</script>
<style scoped lang="scss">

.process {
  .ms-auto {
    text-align: right;
  }

  .sub-title, .help-text {
    color: #ffffff;
  }

  color: #fff;
  background-image: linear-gradient(to right bottom, #3b81f6, #347af4, #2e72f1, #296bee, #2563eb);

  .progress {
    height: 25px;
    border-radius: 13px;
    background-color: var(--light-blue);
    .progress-bar{
      background-color: var(--white)!important;
      color: var(--primary);
      border-radius: 13px;
    }
  }
}

.line {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;

  &.bottom {
    font-size: 14px;
    color: var(--deep-blue);
  }
}

@media (width < 768px) {
        .title{
    background: transparent!important;
  }

}

</style>

